import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import {
    BestellungExtern,
    BestellungExternDokument,
    BestellungExternPosition,
    istFremdlaborBestellung,
} from '../../bestellung-extern/bestellung-extern';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { ConfirmDeleteDialogComponent } from '../../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import {
    InvoiceDeliverNoteDialogComponent,
    WareneingangScanKind,
} from '../../bestellung-extern/invoice-deliver-note-dialog/invoice-deliver-note-dialog.component';
import { FileUploadService } from '../../../dialogs/file-upload-dialog/file-upload.service';
import { DatePipe } from '@angular/common';
import { AddCommentDialogComponent } from '../add-comment-dialog/add-comment-dialog.component';
import { Router } from '@angular/router';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AddGutschriftDialogComponent } from '../../gutschriften/add-gutschrift-dialog/add-gutschrift-dialog.component';
import { Gutschrift } from '../../gutschriften/gutschrift';
import { ShowGutschriftenDialogComponent } from '../show-gutschriften-dialog/show-gutschriften-dialog.component';
import { ConfirmDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { EnterValueDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import {
    EnterValueInput,
    EnterValueResponse,
} from '../../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { BestellungExternService } from '../../bestellung-extern/bestellung-extern.service';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { Subscription } from 'rxjs';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import {
    FilterItem,
    FilterItemType,
} from '../../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { NebenkostenPrimanotaVorschauDialogComponent } from '../../gemeinkosten/gemeinkosten-invoice-review/nebenkosten-primanota-vorschau-dialog.component';
import { PrimanotaExportVorschauData } from '../../gemeinkosten/gemeinkosten-invoice-review/nebenkosten-primanota-vorschau-dialog.models';
import { isEinkaufLaborArticle, isEinkaufVerbrauchArticle } from '../../../warehouse/material/material';
import { MaterialDetailsComponent } from '../../../warehouse/material/material-details/material-details.component';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
    selector: 'kiene-bestellung-extern-list',
    templateUrl: './bestellung-extern-list.component.html',
    styleUrls: ['./bestellung-extern-list.component.scss'],
})
export class BestellungExternListComponent implements OnInit {
    @ViewChild('topPaginator') topPaginator: MatPaginator;
    @ViewChild('bottomPaginator') bottomPaginator: MatPaginator;
    @ViewChild('invoiceKiFileInput') invoiceKiFileInput: ElementRef<HTMLInputElement>;
    private pendingScanKind?: WareneingangScanKind;

    offset = 0;
    limit = 10;
    totalLength = 100;

    bestellungenExtern: BestellungExtern[] = [];

    bestellungRechnungArray: number[] = [];

    searchValue = '';
    searchCtrl = new UntypedFormControl();
    lieferantSearchCtrl = new UntypedFormControl('');

    invoiceModeActive = false;
    selectedLieferantId = -1;
    lieferanten: { lieferant_id: number; bezeichnung: string }[] = [];
    /** Leer bzw. alle IDs = kein Lieferantenfilter (Standard). */
    allLieferantenSelected = true;
    filterLieferantIds: number[] = [];
    teilweiseGeliefertFilter = false;
    preisAbweichendOhnePrimanotaFilter = false;
    checkedFilterCount: number = null;
    /** alle | umsatz | verbrauch */
    verbrauchKind: 'alle' | 'umsatz' | 'verbrauch' = 'alle';
    /** alle | praxis | labor */
    laborKind: 'alle' | 'praxis' | 'labor' = 'praxis';
    /** Innerhalb Labor: beide Warengruppen, nur Laborartikel oder nur Diagnostik. */
    artikelArt: 'alle' | 'laborartikel' | 'diagnostik' = 'alle';

    filterItems: FilterItem[] = [
        new FilterItem('Offen', 21, FilterItemType.CHECKBOX, 'status_id'),
        new FilterItem('Freigegeben', 22, FilterItemType.CHECKBOX, 'status_id'),
        new FilterItem('Bestellt', [23, 24, 25, 29], FilterItemType.CHECKBOX, 'status_id'),
        new FilterItem('Teilweise geliefert', 27, FilterItemType.CHECKBOX, 'status_id'),
        new FilterItem('Geliefert', [26, 30], FilterItemType.CHECKBOX, 'status_id'),
        new FilterItem('Storniert', 28, FilterItemType.CHECKBOX, 'status_id'),
        new FilterItem(
            'Bestellungen mit fehlender Rechnung',
            '1',
            FilterItemType.CHECKBOX,
            'fehlende_rechnung',
        ),
        new FilterItem('Ohne Lieferschein', '1', FilterItemType.CHECKBOX, 'ohne_ls'),
        new FilterItem('Ungeprüft', '1', FilterItemType.CHECKBOX, 'ungeprueft'),
        new FilterItem('Mengen-Diff', '1', FilterItemType.CHECKBOX, 'mengen_diff'),
        new FilterItem('Primanota-bereit', '1', FilterItemType.CHECKBOX, 'primanota_bereit'),
        new FilterItem(
            'Abweichende Preise ohne Primanota',
            '1',
            FilterItemType.CHECKBOX,
            'preis_abweichend',
            false,
            { permissionId: 1725 },
        ),
        new FilterItem(
            'Nicht vollständig geliefert (>4 Wochen)',
            '1',
            FilterItemType.CHECKBOX,
            'teilweise_geliefert',
        ),
        new FilterItem('Mit Gutschrift', '1', FilterItemType.CHECKBOX, 'mit_gutschrift'),
        new FilterItem('Mit Kommentar', '1', FilterItemType.CHECKBOX, 'mit_kommentar'),
        new FilterItem('Zusammengeführt', '1', FilterItemType.CHECKBOX, 'zusammengefuehrt'),
        new FilterItem('Chargenpflichtig ohne Charge', '1', FilterItemType.CHECKBOX, 'ohne_charge'),
    ];

    searchCtrlSubscription: Subscription;
    loadBestellungSub: Subscription;

    /** UI-Einstellungen (tabellen_einstellungen / BestellungExternLieferanten) */
    kommentareAnzeigen = false;

    private readonly uiSettingsTabelle = 'BestellungExternLieferanten';

    constructor(
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly api: KieneBackendApiService,
        private readonly session: LocalStorageService,
        private readonly pdf: PdfViewerDesktopService,
        public dialog: MatDialog,
        private readonly messageService: MessageService,
        private readonly uploadService: FileUploadService,
        private readonly http: HttpClient,
        private readonly datePipe: DatePipe,
        private readonly router: Router,
        private readonly bestellungExternService: BestellungExternService,
    ) {}

    ngOnInit() {
        this.limit = this.session.getCurrentUser().elemente_pro_seite;

        this.searchCtrlSubscription = this.searchCtrl.valueChanges
            .pipe(debounceTime(300), distinctUntilChanged())
            .subscribe(value => {
                this.searchValue = value;
                this.loadBestellungenExtern();
            });

        this.loadUiSettings();
        if (this.laborOnly) {
            this.laborKind = 'labor';
        } else {
            // Mandant-Admin / Praxis: Standard Praxis, Labor weiterhin wählbar
            this.laborKind = 'praxis';
        }
        this.loadLieferanten();
        this.loadBestellungenExtern();
    }

    get visibleLieferanten(): { lieferant_id: number; bezeichnung: string }[] {
        const q = String(this.lieferantSearchCtrl.value || '')
            .trim()
            .toLowerCase();
        if (!q) {
            return this.lieferanten;
        }
        return this.lieferanten.filter(l => (l.bezeichnung || '').toLowerCase().includes(q));
    }

    get laborOnly(): boolean {
        return this.session.hasExplicitPermission(1082) && !this.session.hasExplicitPermission(1081);
    }

    get kannPraxisSammelbestellen(): boolean {
        return this.session.hasExplicitPermission(1769);
    }

    get kannLaborSammelbestellen(): boolean {
        return this.session.hasExplicitPermission(1082);
    }

    get sammelbestellenGesperrt(): boolean {
        if (this.laborKind === 'labor') {
            return !this.kannLaborSammelbestellen;
        }
        if (this.laborKind === 'praxis') {
            return !this.kannPraxisSammelbestellen;
        }
        return true;
    }

    kannArtikelOeffnen(p: BestellungExternPosition): boolean {
        return Number(p?.artikel_id) > 0 && this.hasPermission(1001) && !this.laborOnly;
    }

    openArtikelDetails(p: BestellungExternPosition, event?: Event) {
        event?.stopPropagation();
        const id = Number(p?.artikel_id);
        if (!this.kannArtikelOeffnen(p)) {
            return;
        }
        this.dialog
            .open(MaterialDetailsComponent, {
                width: '1100px',
                maxWidth: '96vw',
                height: '90vh',
                autoFocus: false,
                panelClass: ['material-details-dialog-panel', 'mat-dialog-no-padding'],
                data: { artikelId: id },
            })
            .afterClosed()
            .subscribe(() => this.loadBestellungenExtern());
    }

    loadLieferanten() {
        let params = new HttpParams();
        if (this.verbrauchKind === 'verbrauch') {
            params = params.set('einkauf_verbrauch', '1');
        } else if (this.verbrauchKind === 'umsatz') {
            params = params.set('einkauf_verbrauch', '0');
        }
        if (this.laborKind === 'labor') {
            params = params.set('einkauf_labor', '1');
            if (this.artikelArt !== 'alle') {
                params = params.set('einkauf_artikelart', this.artikelArt);
            }
        } else if (this.laborKind === 'praxis') {
            params = params.set('einkauf_labor', '0');
        }
        this.api.get(this.apiBaseUrl + 'bestellung_extern/read_lieferanten.php', params).subscribe({
            next: response => {
                this.lieferanten = Array.isArray(response?.records) ? response.records : [];
                this.pruneLieferantFilter();
            },
            error: error => {
                this.messageService.errorMessage('Lieferanten konnten nicht geladen werden.', error);
            },
        });
    }

    private pruneLieferantFilter() {
        if (this.allLieferantenSelected) {
            return;
        }
        const ids = new Set(this.lieferanten.map(l => Number(l.lieferant_id)));
        this.filterLieferantIds = this.filterLieferantIds.filter(id => ids.has(Number(id)));
        if (this.filterLieferantIds.length === 0) {
            this.allLieferantenSelected = true;
        }
    }

    isLieferantFilterActive(lieferantId: number): boolean {
        return !this.allLieferantenSelected && this.filterLieferantIds.some(id => KieneUtils.sameId(id, lieferantId));
    }

    selectAlleLieferanten() {
        this.allLieferantenSelected = true;
        this.filterLieferantIds = [];
        this.resetListPaging();
        this.loadBestellungenExtern();
    }

    toggleLieferantFilter(lieferantId: number) {
        if (this.allLieferantenSelected) {
            this.allLieferantenSelected = false;
            this.filterLieferantIds = [lieferantId];
        } else if (this.filterLieferantIds.some(id => KieneUtils.sameId(id, lieferantId))) {
            this.filterLieferantIds = this.filterLieferantIds.filter(id => !KieneUtils.sameId(id, lieferantId));
            if (this.filterLieferantIds.length === 0) {
                this.allLieferantenSelected = true;
            }
        } else {
            this.filterLieferantIds = [...this.filterLieferantIds, lieferantId];
            if (this.filterLieferantIds.length === this.lieferanten.length) {
                this.allLieferantenSelected = true;
                this.filterLieferantIds = [];
            }
        }
        this.resetListPaging();
        this.loadBestellungenExtern();
    }

    private resetListPaging() {
        this.offset = 0;
        if (this.topPaginator) {
            this.topPaginator.pageIndex = 0;
        }
        if (this.bottomPaginator) {
            this.bottomPaginator.pageIndex = 0;
        }
    }

    setCheckedFilterCount(count: number) {
        this.checkedFilterCount = count > 0 ? count : null;
    }

    updatedFilterItems(items: FilterItem[]) {
        if (items) {
            this.filterItems = items;
        }
        this.invoiceModeActive = this.isFilterChecked('fehlende_rechnung');
        this.preisAbweichendOhnePrimanotaFilter = this.isFilterChecked('preis_abweichend');
        this.teilweiseGeliefertFilter = this.isFilterChecked('teilweise_geliefert');
        this.loadBestellungenExtern();
    }

    private isFilterChecked(name: string): boolean {
        return this.filterItems.find(item => item.name === name)?.checked === true;
    }

    private appendStatusFilterParams(params: HttpParams): HttpParams {
        for (const fi of this.filterItems) {
            if (fi.name !== 'status_id' || !fi.checked) {
                continue;
            }
            const values = Array.isArray(fi.value) ? fi.value : [fi.value];
            for (const v of values) {
                params = params.append('status_id[]', String(v));
            }
        }
        return params;
    }

    loadUiSettings() {
        const params = new HttpParams().set('tabelle', this.uiSettingsTabelle);
        this.api.get(this.apiBaseUrl + 'tabelle_einstellung/read_einstellung.php', params).subscribe({
            next: (value: { suchtext?: string }) => {
                if (!value?.suchtext) {
                    return;
                }
                try {
                    const parsed = JSON.parse(value.suchtext);
                    this.kommentareAnzeigen = !!parsed.kommentareAnzeigen;
                } catch {
                    // legacy / leer
                }
            },
        });
    }

    saveUiSettings() {
        const payload = {
            tabelle: this.uiSettingsTabelle,
            suchtext: JSON.stringify({
                kommentareAnzeigen: this.kommentareAnzeigen,
            }),
        };
        this.api.updateGeneric(this.apiBaseUrl + 'tabelle_einstellung/update.php', payload).subscribe({
            error: err => this.messageService.errorMessage('UI-Einstellungen konnten nicht gespeichert werden.', err),
        });
    }

    toggleKommentareAnzeigen() {
        this.kommentareAnzeigen = !this.kommentareAnzeigen;
        this.saveUiSettings();
    }

    get sichtbareBestellungen(): BestellungExtern[] {
        return (this.bestellungenExtern || []).filter(be => this.getVisiblePositionen(be).length > 0);
    }

    getVisiblePositionen(be: BestellungExtern): BestellungExternPosition[] {
        const positionen = be.positionen || [];
        return positionen.filter(p => this.positionPasstZuEinkaufFilter(p, be));
    }

    private positionPasstZuEinkaufFilter(p: BestellungExternPosition, be: BestellungExtern): boolean {
        if (this.preisAbweichendOhnePrimanotaFilter && !this.istPreisAbweichendOhnePrimanota(p, be)) {
            return false;
        }
        const labor = isEinkaufLaborArticle(p);
        if (this.verbrauchKind === 'verbrauch' && !isEinkaufVerbrauchArticle(p, labor)) {
            return false;
        }
        if (this.verbrauchKind === 'umsatz' && isEinkaufVerbrauchArticle(p, labor)) {
            return false;
        }
        if (this.laborKind === 'labor' && this.artikelArt === 'laborartikel') {
            return String(p?.warengruppe || '') === 'Laborartikel';
        }
        if (this.laborKind === 'labor' && this.artikelArt === 'diagnostik') {
            return (
                Number(be?.untersuchungsauftrag_id) > 0 ||
                String(p?.warengruppe || '') === 'Diagnostikartikel'
            );
        }
        if (this.laborKind === 'labor' && !labor) {
            return false;
        }
        if (this.laborKind === 'praxis' && labor) {
            return false;
        }
        return true;
    }

    setArtikelArt(art: 'alle' | 'laborartikel' | 'diagnostik') {
        this.artikelArt = art;
        this.allLieferantenSelected = true;
        this.filterLieferantIds = [];
        this.resetListPaging();
        this.loadLieferanten();
        this.loadBestellungenExtern();
    }

    setVerbrauchKind(event: MatButtonToggleChange) {
        this.verbrauchKind = event.value || 'alle';
        this.resetListPaging();
        this.loadLieferanten();
        this.loadBestellungenExtern();
    }

    setLaborKind(event: MatButtonToggleChange) {
        if (this.laborOnly) {
            this.laborKind = 'labor';
            return;
        }
        this.laborKind = event.value || 'alle';
        this.resetListPaging();
        this.loadLieferanten();
        this.loadBestellungenExtern();
    }

    istPreisAbweichendOhnePrimanota(p: BestellungExternPosition, be?: BestellungExtern): boolean {
        return !(p.primanota_id > 0) && this.isPreisAbweichend(p, be);
    }

    editPositionKommentar(p: BestellungExternPosition, event?: Event) {
        event?.stopPropagation();
        if (p.primanota_id > 0) {
            return;
        }
        const input = new EnterValueInput();
        input.title = 'Positions-Kommentar';
        input.addInputValue('Kommentar', 'textarea', p.kommentar ?? '');
        this.dialog
            .open(EnterValueDialogComponent, { width: '50%', minWidth: '320px', data: input })
            .afterClosed()
            .subscribe({
                next: (result: EnterValueResponse) => {
                    if (!result?.result) {
                        return;
                    }
                    const kommentar = result.getValue(0) ?? '';
                    this.api
                        .updateGeneric(this.apiBaseUrl + 'bestellung_extern/update_position_preis.php', {
                            bea_id: p.bea_id,
                            kommentar,
                        })
                        .subscribe({
                            next: () => {
                                p.kommentar = kommentar;
                            },
                            error: err =>
                                this.messageService.errorMessage('Kommentar konnte nicht gespeichert werden.', err),
                        });
                },
            });
    }

    hatBestellKommentar(be: BestellungExtern): boolean {
        return !!(be.kommentar && be.kommentar.trim());
    }

    isPreisAbweichend(p: BestellungExternPosition, be?: BestellungExtern): boolean {
        if (be?.untersuchungsauftrag_id || p.primanota_id > 0) {
            return false;
        }
        if (p.preis_abweichend > 0) {
            return true;
        }
        return this.istPreisAutomatischAbweichend(p);
    }

    istManuellAlsAbweichendMarkiert(p: BestellungExternPosition): boolean {
        return p.preis_abweichend > 0;
    }

    istPreisAutomatischAbweichend(p: BestellungExternPosition): boolean {
        const lieferant = p.einzelpreis_lieferant;
        if (lieferant == null || p.einzelpreis == null) {
            return false;
        }
        return Math.abs(Number(p.einzelpreis) - Number(lieferant)) > 0.00001;
    }

    getPreisAbweichendTooltip(p: BestellungExternPosition): string {
        if (p.primanota_id > 0) {
            return 'Bereits in Primanota – nicht mehr änderbar';
        }
        if (this.istManuellAlsAbweichendMarkiert(p)) {
            return 'Manuell markiert – klicken zum Entfernen der Markierung';
        }
        if (this.istPreisAutomatischAbweichend(p)) {
            return 'Preis weicht vom Lieferanten-Stamm ab – klicken zum manuell Markieren';
        }
        return 'Preis als abweichend markieren';
    }

    togglePreisAbweichend(p: BestellungExternPosition, event?: Event) {
        event?.stopPropagation();
        if (p.primanota_id > 0) {
            return;
        }
        const neuerWert = p.preis_abweichend > 0 ? 0 : 1;
        this.api
            .updateGeneric(this.apiBaseUrl + 'bestellung_extern/update_position_preis.php', {
                bea_id: p.bea_id,
                preis_abweichend: neuerWert,
            })
            .subscribe({
                next: () => {
                    p.preis_abweichend = neuerWert;
                },
                error: err => this.messageService.errorMessage('Preis-Markierung konnte nicht gespeichert werden.', err),
            });
    }

    hatPreisAbweichungInBestellung(be: BestellungExtern): boolean {
        if (be?.untersuchungsauftrag_id) {
            return false;
        }
        return (be.positionen || []).some(p => this.isPreisAbweichend(p, be));
    }

    getFormattedDate(d: Date): string {
        let formattedDate = '';

        if (!d) {
            return formattedDate;
        }

        const now = new Date();
        d = new Date(d);

        const hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours().toString();
        const minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes().toString();

        // heute?
        if (d.getDate() === now.getDate() && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear()) {
            formattedDate = 'heute um ' + hours + ':' + minutes;
        } else if (
            d.getDate() === now.getDate() - 1 &&
            d.getMonth() === now.getMonth() &&
            d.getFullYear() === now.getFullYear()
        ) {
            formattedDate = 'gestern um ' + hours + ':' + minutes;
        } else {
            formattedDate = this.datePipe.transform(d, 'dd.MM.yyyy HH:mm');
        }

        return formattedDate;
    }

    topPageChanged(event: PageEvent) {
        this.offset = event.pageIndex * event.pageSize;
        this.limit = event.pageSize;
        this.bottomPaginator.pageSize = event.pageSize;
        this.bottomPaginator.pageIndex = event.pageIndex;
        this.loadBestellungenExtern();
    }

    bottomPageChanged(event: PageEvent) {
        this.offset = event.pageIndex * event.pageSize;
        this.limit = event.pageSize;
        this.topPaginator.pageSize = event.pageSize;
        this.topPaginator.pageIndex = event.pageIndex;
        this.loadBestellungenExtern();
    }

    loadBestellungenExtern() {
        let params = new HttpParams();
        params = params.append('offset', this.offset.toString());
        params = params.append('limit', this.limit.toString());
        params = params.append('orderby', 'erstellt desc');
        if (this.searchValue) {
            params = params.append('search', this.searchValue);
        }
        params = this.appendStatusFilterParams(params);
        if (this.invoiceModeActive) {
            params = params.append('rechnungen', '0');
        }
        if (this.isFilterChecked('ohne_ls')) {
            params = params.set('ohne_ls', '1');
        }
        if (this.isFilterChecked('ungeprueft')) {
            params = params.set('ungeprueft', '1');
        }
        if (this.isFilterChecked('mengen_diff')) {
            params = params.set('mengen_diff', '1');
        }
        if (this.isFilterChecked('primanota_bereit')) {
            params = params.set('primanota_bereit', '1');
        }
        if (this.teilweiseGeliefertFilter) {
            params = params.set('vollstaendig', '0');
        }
        if (this.preisAbweichendOhnePrimanotaFilter) {
            params = params.set('preis_abweichend_ohne_primanota', '1');
        }
        if (this.isFilterChecked('mit_gutschrift')) {
            params = params.set('mit_gutschrift', '1');
        }
        if (this.isFilterChecked('mit_kommentar')) {
            params = params.set('mit_kommentar', '1');
        }
        if (this.isFilterChecked('zusammengefuehrt')) {
            params = params.set('zusammengefuehrt', '1');
        }
        if (this.isFilterChecked('ohne_charge')) {
            params = params.set('ohne_charge', '1');
        }
        if (this.verbrauchKind === 'verbrauch') {
            params = params.set('einkauf_verbrauch', '1');
        } else if (this.verbrauchKind === 'umsatz') {
            params = params.set('einkauf_verbrauch', '0');
        }
        if (this.laborKind === 'labor') {
            params = params.set('einkauf_labor', '1');
            if (this.artikelArt !== 'alle') {
                params = params.set('einkauf_artikelart', this.artikelArt);
            }
        } else if (this.laborKind === 'praxis') {
            params = params.set('einkauf_labor', '0');
        }
        if (!this.allLieferantenSelected) {
            for (const id of this.filterLieferantIds) {
                params = params.append('lieferant_id[]', String(id));
            }
        }
        this.loadBestellungSub?.unsubscribe();
        this.loadBestellungSub = this.api.get(this.apiBaseUrl + 'bestellung_extern/read.php', params).subscribe({
            next: response => {
                this.bestellungenExtern = response.records;
                this.totalLength = response.count;
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Laden der Bestellungen aufgetreten!', error);
            },
        });
    }

    addToBestellungRechnungArray(event: MatCheckboxChange, be: BestellungExtern) {
        if (event.checked) {
            this.selectedLieferantId = be.lieferant_id;
            this.bestellungRechnungArray.push(be.bestellung_extern_id);
        } else {
            const index = this.bestellungRechnungArray.findIndex(id =>
                KieneUtils.sameId(id, be.bestellung_extern_id),
            );
            if (index > -1) {
                this.bestellungRechnungArray.splice(index, 1);
            }

            if (this.bestellungRechnungArray.length === 0) {
                this.selectedLieferantId = -1;
            }
        }
    }

    reload() {
        this.loadBestellungenExtern();
    }

    mergeBestellungen() {
        const input = new ConfirmDialogInput();
        input.headline = 'Bestellungen zusammenführen';
        input.text = 'Wollen Sie die markierten Bestellungen zu einer zusammenführen?';
        input.okButton = 'Zusammenführen';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '33%', minWidth: '300px', data: input });

        dialogRef.afterClosed().subscribe({
            next: (result: ConfirmDialogResult) => {
                if (result?.confirmed) {
                    const obj = { bestellung_extern_ids: this.bestellungRechnungArray };
                    this.api.post(this.apiBaseUrl + 'bestellung_extern/merge.php', obj, null).subscribe(
                        () => {
                            this.messageService.infoMessage('Bestellungen erfolgreich zusammengeführt!');
                            this.reload();
                        },
                        error => {
                            this.messageService.errorMessage('Fehler beim Zusammenführen aufgetreten!', error);
                            this.reload();
                        },
                    );
                }
            },
        });
    }

    openInvoiceKiFilePicker(kind?: WareneingangScanKind) {
        this.pendingScanKind = kind;
        const input = this.invoiceKiFileInput?.nativeElement;
        if (!input) {
            return;
        }
        input.value = '';
        input.click();
    }

    onInvoiceKiFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        const selected = input.files ? Array.from(input.files) : [];
        input.value = '';
        if (selected.length === 0) {
            return;
        }
        this.openInvoiceDeliveryNoteDialog(selected, undefined, this.pendingScanKind);
    }

    openInvoiceDeliveryNoteDialog(
        files: File[] | FileList,
        be?: BestellungExtern,
        preferredKind?: WareneingangScanKind,
    ) {
        const fileArr = Array.from(files || []);
        if (fileArr.length === 0) {
            return;
        }
        const dialogRef = this.dialog.open(InvoiceDeliverNoteDialogComponent, {
            width: '100vw',
            maxWidth: '100vw',
            height: '100vh',
            panelClass: ['gemeinkosten-scan-review-dialog-panel', 'mat-dialog-no-padding'],
            data: {
                files: fileArr,
                bestellung: be || null,
                candidates: this.bestellungenExtern || [],
                preferredKind,
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (!result) {
                return;
            }
            const target = result.bestellung || be;
            if (result.saved) {
                this.loadBestellungenExtern();
                if (result.extraFiles?.length && target) {
                    this.uploadRemainingScanFiles(result.extraFiles, target, result.kind);
                }
                return;
            }
            if (!target) {
                this.messageService.infoMessage('Keine Bestellung für die Zuordnung gewählt.');
                return;
            }
            if (result.kind === 'invoice') {
                this.uploadService.uploadFilesToServerForMultipleEntities(
                    fileArr,
                    'bestellung_extern_ids',
                    [target.bestellung_extern_id],
                    'bestellung_extern_dokument/create_rechnung.php',
                    undefined,
                    (fileName: string, progress: number) => {},
                    response => {
                        this.openRechnungBestellpositonenCheckDialog(target, response);
                    },
                    () => {
                        this.loadBestellungenExtern();
                    },
                );
            } else if (result.kind === 'deliveryNote') {
                this.uploadService.uploadFilesToServerForMultipleEntities(
                    fileArr,
                    'bestellung_extern_ids',
                    [target.bestellung_extern_id],
                    'bestellung_extern_dokument/create_lieferschein.php',
                    new Date(),
                    (fileName: string, progress: number) => {},
                    response => {},
                    () => {
                        this.loadBestellungenExtern();
                    },
                );
            } else if (result.kind === 'credit') {
                this.openAddGutschriftDialog(fileArr, target);
            }
        });
    }

    private uploadRemainingScanFiles(files: File[], be: BestellungExtern, kind: string) {
        if (kind === 'credit') {
            this.openAddGutschriftDialog(files, be);
            return;
        }
        const endpoint =
            kind === 'invoice'
                ? 'bestellung_extern_dokument/create_rechnung.php'
                : 'bestellung_extern_dokument/create_lieferschein.php';
        this.uploadService.uploadFilesToServerForMultipleEntities(
            files,
            'bestellung_extern_ids',
            [be.bestellung_extern_id],
            endpoint,
            kind === 'invoice' ? undefined : new Date(),
            () => {},
            () => {},
            () => {
                this.loadBestellungenExtern();
            },
        );
    }

    openAddGutschriftDialog(files: File[], be: BestellungExtern) {
        const gutschrift = new Gutschrift();
        gutschrift.lieferant = be.lieferant;
        gutschrift.lieferant_id = be.lieferant_id;
        gutschrift.bestellung_extern_id = be.bestellung_extern_id;

        const dialogRef = this.dialog.open(AddGutschriftDialogComponent, {
            data: { filesToUpload: files, gutschrift: gutschrift, apiUrl: 'gutschrift/update.php' },
        });

        dialogRef.afterClosed().subscribe(response => {
            this.reload();
        });
    }

    openPrimanotaExportVorschau() {
        this.http
            .post<PrimanotaExportVorschauData>(this.apiBaseUrl + 'primanota/vorschau_lieferanten.php', {
                arzneimittel: 1,
            })
            .subscribe({
                next: data => {
                    this.dialog.open(NebenkostenPrimanotaVorschauDialogComponent, {
                        width: '920px',
                        maxWidth: '96vw',
                        data,
                    });
                },
                error: err => {
                    this.messageService.errorMessage('Primanota-Vorschau fehlgeschlagen.', err);
                },
            });
    }

    generatePrimanota() {
        const input = new ConfirmDialogInput();
        input.headline = 'Primanota erstellen';
        input.text =
            'Soll die Primanota für alle offenen Positionen im Reiter "Bestellungen" erstellt werden? Es wird noch die bisherige Lieferanten-Buchung (Alt) erzeugt. Die Artikel-Buchung (Neu) steht in der Primanota-Vorschau.';
        input.okButton = 'Erstellen';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '50%', minWidth: '300px', data: input });

        dialogRef.afterClosed().subscribe({
            next: (result: ConfirmDialogResult) => {
                if (result?.confirmed) {
                    this.http
                        .post(this.apiBaseUrl + 'primanota/generieren_lieferanten.php', { arzneimittel: 1 })
                        .subscribe({
                            next: () => {
                                this.messageService.infoMessage('Die Primanota wurde erfolgreich generiert!');
                                this.router.navigate(['/finanzen', 'primanota']);
                            },
                            error: err => {
                                this.messageService.errorMessage(
                                    'Es ist ein Fehler beim Generieren der Primanota aufgetreten!',
                                    err,
                                );
                            },
                        });
                }
            },
        });
    }

    isChecked(be: BestellungExtern) {
        return KieneUtils.includesId(this.bestellungRechnungArray, be.bestellung_extern_id);
    }

    zeigtUntersuchungsauftrag(be: BestellungExtern): boolean {
        return this.laborKind !== 'praxis' && istFremdlaborBestellung(be);
    }

    hasBestellungExternStatus(be: BestellungExtern, ...statusIds: number[]): boolean {
        return statusIds.some(id => KieneUtils.sameId(be?.status_id, id));
    }

    isBestellungExternStatusBelow(be: BestellungExtern, statusId: number): boolean {
        const status = Number(be?.status_id);
        return !Number.isNaN(status) && status < statusId;
    }

    isLieferantSelectionDisabled(be: BestellungExtern): boolean {
        return Number(this.selectedLieferantId) > 0 && !KieneUtils.sameId(this.selectedLieferantId, be.lieferant_id);
    }

    hasPermission(...ids: number[]) {
        return ids.some(id => this.session.currentUserHasPermission(id));
    }

    /** Entwurf ohne fremde Positionen. Leere Entwürfe gelten als Labor, die Liste ist schon gefiltert. */
    istReineLaborBestellung(be: BestellungExtern): boolean {
        const positionen = be?.positionen || [];
        if (positionen.length === 0) {
            return true;
        }
        return positionen.every(p => Number(p.laborartikel) > 0 || isEinkaufLaborArticle(p));
    }
    download(be: BestellungExtern) {
        this.pdf.openPdfViewer(
            new PdfViewerDialogInput(
                'bestellung_extern/pdf_merged.php',
                new HttpParams().set('bestellung_extern_id', be?.bestellung_extern_id?.toString()),
                'Bestellungen Extern',
            ),
        );
    }

    downloadSingle(bestellungExternId: number, be: BestellungExtern) {
        this.pdf.openPdfViewer(
            new PdfViewerDialogInput(
                'bestellung_extern/pdf_merged.php',
                new HttpParams().set('bestellung_extern_id', bestellungExternId?.toString()),
                'Bestellung Extern an ' + be.lieferant,
            ),
        );
    }

    cancel(be: BestellungExtern) {
        this.openCancelDialog(be);
    }

    delete(be: BestellungExtern) {
        this.openDeleteDialog(be);
    }

    openCancelDialog(be: BestellungExtern) {
        const nummer = be.bestell_nr ? '#' + be.bestell_nr : String(be.bestellung_extern_id);
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '500px',
            data: {
                title: 'Bestellung stornieren',
                text: 'Bestellung ' + nummer + ' wirklich stornieren?',
                textButton: 'stornieren',
            },
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                be.status_id_neu = 28;
                this.api.updateGeneric(this.apiBaseUrl + 'bestellung_extern/update.php', be).subscribe({
                    next: () => {
                        this.messageService.infoMessage('Die Bestellung wurde erfolgreich storniert!');
                        this.reload();
                    },
                    error: error => {
                        this.messageService.errorMessage('Die Bestellung konnte nicht storniert werden! ', error);
                    },
                });
            }
        });
    }

    openDeleteDialog(be: BestellungExtern) {
        const nummer = be.bestell_nr ? '#' + be.bestell_nr : String(be.bestellung_extern_id);
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '500px',
            data: {
                title: 'Bestellung löschen',
                text: 'Bestellung ' + nummer + ' wirklich löschen?',
                textButton: 'löschen',
            },
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                this.api.deleteEntity(this.apiBaseUrl + 'bestellung_extern/delete.php', be).subscribe({
                    next: () => {
                        this.messageService.infoMessage('Die Bestellung wurde erfolgreich gelöscht!');
                        this.reload();
                    },
                    error: error => {
                        this.messageService.errorMessage('Die Bestellung konnte nicht gelöscht werden! ', error);
                    },
                });
            }
        });
    }

    openOrderAllDialog() {
        if (this.sammelbestellenGesperrt) {
            this.messageService.infoMessage('Bitte zuerst Praxis oder Labor wählen.');
            return;
        }
        const labor = this.laborKind === 'labor';
        const input = new ConfirmDialogInput();
        input.headline = labor ? 'Offene Laborbestellungen' : 'Offene Praxisbestellungen';
        input.text = labor
            ? 'Wollen Sie alle offenen Laborbestellungen jetzt bestellen? Untersuchungsaufträge sind dabei.'
            : 'Wollen Sie alle offenen Praxisbestellungen jetzt bestellen?';
        input.okButton = 'Alle Bestellen';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '50%', minWidth: '300px', data: input });

        dialogRef.afterClosed().subscribe({
            next: (result: ConfirmDialogResult) => {
                if (result?.confirmed) {
                    const params = new HttpParams().set('einkauf_labor', labor ? '1' : '0');
                    this.api.post(this.apiBaseUrl + 'bestellung_extern/alle_bestellen.php', {}, params).subscribe(
                        response => {
                            this.messageService.infoMessage(
                                'Es werden alle offenen ' +
                                    (labor ? 'Laborbestellungen' : 'Praxisbestellungen') +
                                    ' (' +
                                    response.bestellungen +
                                    ') jetzt bestellt!',
                            );
                        },
                        error => {
                            this.messageService.errorMessage('Es ist ein Fehler beim Bestellen aufgetreten!', error);
                        },
                    );
                }
            },
        });
    }

    openCommentDialog(be: BestellungExtern) {
        this.dialog
            .open(AddCommentDialogComponent, {
                width: '70%',
                minWidth: '300px',
                data: { bestellungExtern: be },
            })
            .afterClosed()
            .subscribe(saved => {
                if (saved) {
                    this.loadBestellungenExtern();
                }
            });
    }

    summeAllerEinzelpreise(be: BestellungExtern): number {
        let summe = 0.0;

        for (const p of be.positionen) {
            summe += Math.round(p.einzelpreis * p.menge_ist * 100) / 100;
        }

        return summe;
    }

    summeAllerRabattpreise(be: BestellungExtern): number {
        let summe = 0.0;

        for (const p of be.positionen) {
            summe +=
                (Math.round((p.rabatt ? (p.einzelpreis * (100 - p.rabatt)) / 100 : p.einzelpreis) * 100) / 100) *
                p.menge_ist;
        }

        return summe;
    }

    openShowGutschriftenDialog(be: BestellungExtern) {
        this.dialog.open(ShowGutschriftenDialogComponent, { minWidth: '33%', data: { bestellungExtern: be } });
    }

    public openRechnungBestellpositonenCheckDialog(
        be: BestellungExtern,
        bestellungExternDokument: BestellungExternDokument,
    ) {
        const dialogRef = this.dialog.open(InvoiceDeliverNoteDialogComponent, {
            width: '100vw',
            maxWidth: '100vw',
            height: '100vh',
            panelClass: ['gemeinkosten-scan-review-dialog-panel', 'mat-dialog-no-padding'],
            data: {
                files: [],
                bestellung: be,
                candidates: this.bestellungenExtern || [],
                preferredKind: 'invoice',
                dokument: bestellungExternDokument,
            },
        });
        dialogRef.afterClosed().subscribe({
            next: () => {
                this.reload();
            },
        });
    }

    downloadLieferschein(l: BestellungExternDokument) {
        this.pdf.openPdfViewer(
            new PdfViewerDialogInput(
                'bestellung_extern_dokument/read_pdf_lieferschein.php',
                new HttpParams().set('bed_id', l?.bed_id?.toString()),
                l.dateiname,
            ),
        );
    }

    markAsClosed(be: BestellungExtern) {
        const input = new ConfirmDialogInput();
        input.headline = 'Bestellung als geliefert markieren';
        input.text = 'Hiermit wird die Bestellung als vollständig geliefert markiert!';
        input.okButton = 'Vollständig geliefert';
        const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: input });
        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result?.ok) {
                    if (be) {
                        be.status_id_neu = 30;

                        this.bestellungExternService.updateBestellungExtern(be).subscribe({
                            next: response => {
                                be = response;
                                this.messageService.infoMessage(
                                    'Die Bestellung ' + be.bestell_nr + ' wurde erfolgreich als geliefert markiert!',
                                );
                            },
                            error: error => {
                                this.messageService.errorMessage(
                                    'Fehler! Die Bestellung konnte nicht als geliefert markiert werden! ',
                                    error,
                                );
                            },
                        });
                    }
                }
            },
        });
    }

    alleTeilweiseGeliefertAlsGeliefertMarkieren() {
        const input = new ConfirmDialogInput();
        input.headline = 'Alle als geliefert markieren!';
        input.text =
            'Hiermit werden alle Bestellungen, die im Status "teilweise geliefert" und älter als 4 Wochen sind, als geliefert markiert!';
        input.okButton = 'als geliefert markieren';
        const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: input });
        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result?.ok) {
                    this.api.post(this.apiBaseUrl + 'bestellung_extern/geliefert.php', {}, undefined).subscribe({
                        next: () => {
                            this.messageService.infoMessage(
                                'Die entsprechenden Bestellungen wurden erfolgreich als geliefert markiert!',
                            );
                            this.reload();
                        },
                        error: err => {
                            this.messageService.errorMessage('Fehler!', err);
                        },
                    });
                }
            },
        });
    }
}
